import styled from "styled-components";
import { StyledToastProps } from "./types";

export const ToastWrapper = styled.div<StyledToastProps>`
    padding: 1rem;
    color: #1f1f1f;
    font-weight: 500;
    background-color: ${({ type }) =>
        type === "success" ? "#f6ffed" : "#fff2f0"};
    display: flex;
    gap: 10px;
    align-items: center;
    width: max-content;
    border: 0.1px solid
        ${({ type }) => (type === "success" ? "#b7eb8f" : "#ffccc7")};
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 8px;

    #close {
        border-radius: 50%;
        transition: all 100ms ease-out;
        background-color: transparent;
        cursor: pointer;
        &:hover {
            * {
                fill: red;
            }
        }
    }
`;
